import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { TimeSelectPageRoutingModule } from './time-select-routing.module';

import { TimeSelectPage } from './time-select.page';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, TimeSelectPageRoutingModule, TranslateModule.forChild()],
  declarations: [TimeSelectPage]
})
export class TimeSelectPageModule {}
